import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { fadeUp, staggerContainer } from '../utils/constants';
export function Contact() {
  return <section id="contacto" className="py-32 bg-grayLightest relative" data-id="element-12">
      <div className="max-w-7xl mx-auto px-6" data-id="element-13">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-14">
          <motion.div variants={fadeUp} className="mb-16" data-id="element-15">
            <h2 className="heading-brutalist text-4xl md:text-5xl mb-6 text-grayDarkest" data-id="element-16">
              CONTACTO
            </h2>
            <div className="w-24 h-px bg-grayDarkest" data-id="element-17"></div>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-18">
            <motion.div variants={fadeUp} className="space-y-10" data-id="element-19">
              <div className="flex items-start gap-6" data-id="element-20">
                <div className="p-4 bg-white border border-grayMid text-grayDarkest" data-id="element-21">
                  <MapPin size={24} strokeWidth={1.5} data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h4 className="font-montserrat font-bold uppercase tracking-wider mb-2 text-lg text-grayDarkest" data-id="element-24">
                    Dirección
                  </h4>
                  <p className="text-grayDarkest font-light" data-id="element-25">
                    Av. San Martín 1250, Piso 8<br data-id="element-26" />
                    Neuquén, Argentina
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-27">
                <div className="p-4 bg-white border border-grayMid text-grayDarkest" data-id="element-28">
                  <Phone size={24} strokeWidth={1.5} data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h4 className="font-montserrat font-bold uppercase tracking-wider mb-2 text-lg text-grayDarkest" data-id="element-31">
                    Teléfono
                  </h4>
                  <p className="text-grayDarkest font-light" data-id="element-32">
                    +54 299 519-2151
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-33">
                <div className="p-4 bg-white border border-grayMid text-grayDarkest" data-id="element-34">
                  <Mail size={24} strokeWidth={1.5} data-id="element-35" />
                </div>
                <div data-id="element-36">
                  <h4 className="font-montserrat font-bold uppercase tracking-wider mb-2 text-lg text-grayDarkest" data-id="element-37">
                    Email
                  </h4>
                  <p className="text-grayDarkest font-light" data-id="element-38">
                    contacto@velascoasociados.com
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-39">
                <div className="p-4 bg-white border border-grayMid text-grayDarkest" data-id="element-40">
                  <Clock size={24} strokeWidth={1.5} data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <h4 className="font-montserrat font-bold uppercase tracking-wider mb-2 text-lg text-grayDarkest" data-id="element-43">
                    Horario de Atención
                  </h4>
                  <p className="text-grayDarkest font-light" data-id="element-44">
                    Lunes a Viernes
                    <br data-id="element-45" />
                    9:00 - 18:00 hs
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div variants={fadeUp} className="h-[400px] bg-white border border-grayMid relative flex items-center justify-center overflow-hidden group" data-id="element-46">
              <div className="relative z-10 text-center" data-id="element-47">
                <MapPin size={48} strokeWidth={1} className="text-grayDarkest mx-auto mb-4 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-48" />
                <p className="font-montserrat uppercase tracking-widest text-sm text-grayDarkest font-semibold" data-id="element-49">
                  Ubicación de Oficinas
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}